<template>
  <div>
    <v-select
      :items="larosateOptions"
      v-model="larosate"
      label="Lärosäte"
      dense
      outlined
      clearable
      hide-details
    />
  </div>
</template>

<script>
import { larosateOptions } from '@/assets/data/options'

export default {
  name: 'FilterLarosate',
  props: {
    article_name: { type: String },
  },
  data() {
    return {
      larosateOptions,
    }
  },
  computed: {
    larosate: {
      get() {
        if (!this.article_name) return null
        return this.article_name.trim()
      },
      set(value) {
        this.$emit('change', { key: 'article_name', value })
      },
    },
  },
}
</script>

<style lang="less" scoped></style>
